(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Voedingsreis-klein"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ---- star field ----
  var starField = document.getElementById('starField');
  var starCount = 45;
  for(var i=0;i<starCount;i++){
    var s = document.createElement('div');
    var big = Math.random() < 0.15;
    var twinkle = Math.random() < 0.35;
    s.className = 'star' + (big ? ' big' : '') + (twinkle ? ' twinkle' : '');
    s.style.left = (Math.random()*100) + '%';
    s.style.top = (Math.random()*85) + '%';
    if(twinkle) s.style.animationDelay = (Math.random()*4) + 's';
    starField.appendChild(s);
  }

  // ---- toggle still feeding ----
  var stillYes = document.getElementById('stillYes');
  var stillNo = document.getElementById('stillNo');
  var endDateField = document.getElementById('endDateField');
  var stillFeeding = true;

  stillYes.addEventListener('click', function(){
    stillFeeding = true;
    stillYes.classList.add('active');
    stillNo.classList.remove('active');
    endDateField.style.display = 'none';
  });
  stillNo.addEventListener('click', function(){
    stillFeeding = false;
    stillNo.classList.add('active');
    stillYes.classList.remove('active');
    endDateField.style.display = 'block';
  });

  // ---- slider ----
  var slider = document.getElementById('hoursSlider');
  var hoursValue = document.getElementById('hoursValue');
  slider.addEventListener('input', function(){
    hoursValue.textContent = slider.value;
  });

  // ---- facts pool ----
  function buildFacts(totalHours){
    return [
      { icon: '📺', text: 'Je had de hele serie Friends ' + fmt(totalHours/86.5) + ' keer kunnen uitkijken.' },
      { icon: '🏃', text: 'Dat komt overeen met ' + fmt(totalHours/4.5) + ' marathons op recreatietempo.' },
      { icon: '✈️', text: 'Je had er ' + fmt(totalHours/40) + ' keer non-stop mee rond de wereld kunnen vliegen.' },
      { icon: '📖', text: 'Genoeg tijd om de hele Harry Potter-reeks ' + fmt(totalHours/41) + ' keer hardop voor te lezen.' },
      { icon: '💼', text: 'Omgerekend zijn dat ' + fmt(totalHours/40) + ' volledige werkweken van 40 uur.' },
      { icon: '💶', text: 'Bij een uurloon van €14 had je hiermee ongeveer €' + fmt(totalHours*14, true) + ' verdiend.' },
      { icon: '😴', text: 'Dat zijn zo\'n ' + fmt(totalHours/8) + ' volledige nachten slaap die je had kunnen pakken.' }
    ];
  }

  function fmt(n, isMoney){
    if(isMoney) return Math.round(n).toLocaleString('nl-NL');
    if(n < 1) return n.toFixed(1).replace('.', ',');
    return Math.round(n).toLocaleString('nl-NL');
  }

  var currentFacts = [];
  var factsList = document.getElementById('factsList');

  function renderFacts(){
    var pool = currentFacts.slice();
    // shuffle
    for(var i = pool.length -1; i>0; i--){
      var j = Math.floor(Math.random()*(i+1));
      var tmp = pool[i]; pool[i]=pool[j]; pool[j]=tmp;
    }
    var picked = pool.slice(0,3);
    factsList.innerHTML = '';
    picked.forEach(function(f){
      var row = document.createElement('div');
      row.className = 'fact';
      row.innerHTML = '<div class="fact-icon">'+f.icon+'</div><div class="fact-text">'+f.text+'</div>';
      factsList.appendChild(row);
    });
    document.getElementById('shareFact').textContent = picked[0] ? picked[0].text : '';
  }

  document.getElementById('refreshFacts').addEventListener('click', renderFacts);

  // ---- calculation ----
  var formError = document.getElementById('formError');

  document.getElementById('calcBtn').addEventListener('click', function(){
    var startVal = document.getElementById('startDate').value;
    if(!startVal){
      formError.style.display = 'block';
      return;
    }
    formError.style.display = 'none';

    var start = new Date(startVal + 'T00:00:00');
    var end;
    if(stillFeeding){
      end = new Date();
    } else {
      var endVal = document.getElementById('endDate').value;
      end = endVal ? new Date(endVal + 'T00:00:00') : new Date();
    }

    var msPerDay = 1000*60*60*24;
    var totalDays = Math.max(1, Math.round((end - start) / msPerDay));
    var hoursPerDay = parseFloat(slider.value);
    var totalHours = totalDays * hoursPerDay;

    var totalFeeds = Math.round(totalHours * 3); // ~20 min per voeding
    var nightWakes = Math.round(totalDays * 1.5);

    document.getElementById('totalHours').textContent = fmt(totalHours, true);
    document.getElementById('totalDays').textContent = fmt(totalDays, true);
    document.getElementById('totalFeeds').textContent = fmt(totalFeeds, true);
    document.getElementById('nightWakes').textContent = fmt(nightWakes, true);

    var opts = { day: 'numeric', month: 'long', year: 'numeric' };
    var rangeText = start.toLocaleDateString('nl-NL', opts) + ' t/m ' + (stillFeeding ? 'vandaag' : end.toLocaleDateString('nl-NL', opts));
    document.getElementById('dateRange').textContent = rangeText;
    document.getElementById('shareRange').textContent = rangeText;
    document.getElementById('shareHours').textContent = fmt(totalHours, true);

    currentFacts = buildFacts(totalHours);
    renderFacts();

    document.getElementById('results').style.display = 'block';
    document.getElementById('results').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ---- newsletter opt-in (native form submit, opens Shopify's newsletter confirmation in a new tab) ----
  var newsletterForm = document.getElementById('newsletterForm');
  var emailStatus = document.getElementById('emailStatus');

  newsletterForm.addEventListener('submit', function(){
    emailStatus.className = 'email-status success';
    emailStatus.textContent = 'Bedankt! We hebben je aanmelding geopend in een nieuw tabblad.';
  });

  // ---- download share card ----
  document.getElementById('downloadBtn').addEventListener('click', function(){
    var card = document.getElementById('shareCard');
    html2canvas(card, { backgroundColor: null, scale: 2 }).then(function(canvas){
      var link = document.createElement('a');
      link.download = 'mijn-voedingsreis.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    }).catch(function(){
      alert('Downloaden lukte niet. Probeer een schermafbeelding te maken.');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Voedingsreis"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ---- star field ----
  var starField = document.getElementById('starField');
  var starCount = 45;
  for(var i=0;i<starCount;i++){
    var s = document.createElement('div');
    var big = Math.random() < 0.15;
    var twinkle = Math.random() < 0.35;
    s.className = 'star' + (big ? ' big' : '') + (twinkle ? ' twinkle' : '');
    s.style.left = (Math.random()*100) + '%';
    s.style.top = (Math.random()*85) + '%';
    if(twinkle) s.style.animationDelay = (Math.random()*4) + 's';
    starField.appendChild(s);
  }

  // ---- toggle still feeding ----
  var stillYes = document.getElementById('stillYes');
  var stillNo = document.getElementById('stillNo');
  var endDateField = document.getElementById('endDateField');
  var stillFeeding = true;

  stillYes.addEventListener('click', function(){
    stillFeeding = true;
    stillYes.classList.add('active');
    stillNo.classList.remove('active');
    endDateField.style.display = 'none';
  });
  stillNo.addEventListener('click', function(){
    stillFeeding = false;
    stillNo.classList.add('active');
    stillYes.classList.remove('active');
    endDateField.style.display = 'block';
  });

  // ---- slider ----
  var slider = document.getElementById('hoursSlider');
  var hoursValue = document.getElementById('hoursValue');
  slider.addEventListener('input', function(){
    hoursValue.textContent = slider.value;
  });

  // ---- facts pool ----
  function buildFacts(totalHours){
    return [
      { icon: '📺', text: 'Je had de hele serie Friends ' + fmt(totalHours/86.5) + ' keer kunnen uitkijken.' },
      { icon: '🏃‍♀️', text: 'Dat komt overeen met ' + fmt(totalHours/4.5) + ' marathons op recreatietempo.' },
      { icon: '✈️', text: 'Je had er ' + fmt(totalHours/40) + ' keer non-stop mee rond de wereld kunnen vliegen.' },
      { icon: '📖', text: 'Genoeg tijd om de hele Harry Potter-reeks ' + fmt(totalHours/41) + ' keer hardop voor te lezen.' },
      { icon: '💼', text: 'Omgerekend zijn dat ' + fmt(totalHours/40) + ' volledige werkweken van 40 uur.' },
      { icon: '💶', text: 'Bij een uurloon van €14 had je hiermee ongeveer €' + fmt(totalHours*14, true) + ' verdiend.' },
      { icon: '😴', text: 'Dat zijn zo\'n ' + fmt(totalHours/8) + ' volledige nachten slaap die je had kunnen pakken.' }
    ];
  }

  function fmt(n, isMoney){
    if(isMoney) return Math.round(n).toLocaleString('nl-NL');
    if(n < 1) return n.toFixed(1).replace('.', ',');
    return Math.round(n).toLocaleString('nl-NL');
  }

  var currentFacts = [];
  var factsList = document.getElementById('factsList');

  function renderFacts(){
    var pool = currentFacts.slice();
    // shuffle
    for(var i = pool.length -1; i>0; i--){
      var j = Math.floor(Math.random()*(i+1));
      var tmp = pool[i]; pool[i]=pool[j]; pool[j]=tmp;
    }
    var picked = pool.slice(0,3);
    factsList.innerHTML = '';
    picked.forEach(function(f){
      var row = document.createElement('div');
      row.className = 'fact';
      row.innerHTML = '<div class="fact-icon">'+f.icon+'</div><div class="fact-text">'+f.text+'</div>';
      factsList.appendChild(row);
    });
    document.getElementById('shareFact').textContent = picked[0] ? picked[0].text : '';
  }

  document.getElementById('refreshFacts').addEventListener('click', renderFacts);

  // ---- calculation ----
  var formError = document.getElementById('formError');

  document.getElementById('calcBtn').addEventListener('click', function(){
    var startVal = document.getElementById('startDate').value;
    if(!startVal){
      formError.style.display = 'block';
      return;
    }
    formError.style.display = 'none';

    var start = new Date(startVal + 'T00:00:00');
    var end;
    if(stillFeeding){
      end = new Date();
    } else {
      var endVal = document.getElementById('endDate').value;
      end = endVal ? new Date(endVal + 'T00:00:00') : new Date();
    }

    var msPerDay = 1000*60*60*24;
    var totalDays = Math.max(1, Math.round((end - start) / msPerDay));
    var hoursPerDay = parseFloat(slider.value);
    var totalHours = totalDays * hoursPerDay;

    var totalFeeds = Math.round(totalHours * 3); // ~20 min per voeding
    var nightWakes = Math.round(totalDays * 1.5);

    document.getElementById('totalHours').textContent = fmt(totalHours, true);
    document.getElementById('totalDays').textContent = fmt(totalDays, true);
    document.getElementById('totalFeeds').textContent = fmt(totalFeeds, true);
    document.getElementById('nightWakes').textContent = fmt(nightWakes, true);

    var opts = { day: 'numeric', month: 'long', year: 'numeric' };
    var rangeText = start.toLocaleDateString('nl-NL', opts) + ' t/m ' + (stillFeeding ? 'vandaag' : end.toLocaleDateString('nl-NL', opts));
    document.getElementById('dateRange').textContent = rangeText;
    document.getElementById('shareRange').textContent = rangeText;
    document.getElementById('shareHours').textContent = fmt(totalHours, true);

    currentFacts = buildFacts(totalHours);
    renderFacts();

    document.getElementById('results').style.display = 'block';
    document.getElementById('results').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ---- newsletter opt-in (native form submit, opens Shopify's newsletter confirmation in a new tab) ----
  var newsletterForm = document.getElementById('newsletterForm');
  var emailStatus = document.getElementById('emailStatus');

  newsletterForm.addEventListener('submit', function(){
    emailStatus.className = 'email-status success';
    emailStatus.textContent = 'Bedankt! We hebben je aanmelding geopend in een nieuw tabblad.';
  });

  // ---- download share card ----
  document.getElementById('downloadBtn').addEventListener('click', function(){
    var card = document.getElementById('shareCard');
    html2canvas(card, { backgroundColor: null, scale: 2 }).then(function(canvas){
      var link = document.createElement('a');
      link.download = 'mijn-voedingsreis.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    }).catch(function(){
      alert('Downloaden lukte niet. Probeer een schermafbeelding te maken.');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Zwangerschapscalculator-klein"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ---- star field ----
  var starField = document.getElementById('starField');
  var starCount = 45;
  for(var i=0;i<starCount;i++){
    var s = document.createElement('div');
    var big = Math.random() < 0.15;
    var twinkle = Math.random() < 0.35;
    s.className = 'star' + (big ? ' big' : '') + (twinkle ? ' twinkle' : '');
    s.style.left = (Math.random()*100) + '%';
    s.style.top = (Math.random()*85) + '%';
    if(twinkle) s.style.animationDelay = (Math.random()*4) + 's';
    starField.appendChild(s);
  }

  // ---- breastfeeding toggle (just affects copy tone, not gating) ----
  var bfYes = document.getElementById('bfYes');
  var bfNo = document.getElementById('bfNo');
  var wantsBf = true;
  bfYes.addEventListener('click', function(){
    wantsBf = true; bfYes.classList.add('active'); bfNo.classList.remove('active');
  });
  bfNo.addEventListener('click', function(){
    wantsBf = false; bfNo.classList.add('active'); bfYes.classList.remove('active');
  });

  var formError = document.getElementById('formError');

  function expectItemsFor(weeksPregnant, pastDue){
    if(pastDue){
      return [
        {icon:'🎉', text:'Je bent uitgerekend. Je kindje kan nu elk moment komen, of ligt er misschien al.'},
        {icon:'🍼', text:'In de eerste dagen voed je heel vaak: gemiddeld elke 2 tot 3 uur, dag en nacht. Dat is normaal en wordt geleidelijk minder.'},
        {icon:'🫐', text:'Het maagje van een pasgeboren baby is nog piepklein, ongeveer zo groot als een kers, vandaar die frequente voedingen.'}
      ];
    }
    if(weeksPregnant < 28){
      return [
        {icon:'🌱', text:'Je hebt nog alle tijd om je rustig voor te bereiden, geen haast.'},
        {icon:'📋', text:'Een goed moment om alvast na te denken over waar je straks wil voeden, en wat je daarbij fijn zou vinden.'},
        {icon:'💭', text:'Veel ouders merken dat de eerste 6 weken het intensiefst zijn, en dat het daarna geleidelijk makkelijker wordt.'}
      ];
    }
    return [
      {icon:'⏰', text:'De laatste weken zijn een goed moment om je voedingshoekje echt in te richten.'},
      {icon:'🍼', text:'In de eerste weken voed je gemiddeld elke 2 tot 3 uur, dag en nacht, normaal, en het wordt geleidelijk minder.'},
      {icon:'🫐', text:'Het maagje van een pasgeboren baby is nog piepklein, ongeveer zo groot als een kers, vandaar die frequente voedingen.'}
    ];
  }

  document.getElementById('calcBtn').addEventListener('click', function(){
    var val = document.getElementById('dueDate').value;
    if(!val){
      formError.style.display = 'block';
      return;
    }
    formError.style.display = 'none';

    var due = new Date(val + 'T00:00:00');
    var today = new Date();
    today.setHours(0,0,0,0);
    var msPerDay = 1000*60*60*24;
    var daysUntil = Math.round((due - today) / msPerDay);
    var pastDue = daysUntil < 0;

    var weeksPregnant = Math.min(42, Math.max(1, 40 - Math.ceil(daysUntil/7)));

    var countdownLabel = document.getElementById('countdownLabel');
    var countdownNumber = document.getElementById('countdownNumber');
    var countdownUnit = document.getElementById('countdownUnit');
    var trimesterBadge = document.getElementById('trimesterBadge');

    if(pastDue){
      countdownLabel.textContent = 'Je bent uitgerekend, dat is';
      countdownNumber.textContent = Math.abs(daysUntil);
      countdownUnit.textContent = Math.abs(daysUntil) === 1 ? 'dag geleden' : 'dagen geleden';
      trimesterBadge.textContent = 'Voorbij je uitgerekende datum';
    } else {
      countdownLabel.textContent = 'Nog';
      countdownNumber.textContent = daysUntil;
      countdownUnit.textContent = daysUntil === 1 ? 'dag te gaan' : 'dagen te gaan';
      var trimesterText = weeksPregnant <= 13 ? 'Eerste trimester' : (weeksPregnant <= 27 ? 'Tweede trimester' : 'Derde trimester');
      trimesterBadge.textContent = trimesterText + ' (week ' + weeksPregnant + ')';
    }

    var items = expectItemsFor(weeksPregnant, pastDue);
    var expectList = document.getElementById('expectList');
    expectList.innerHTML = '';
    items.forEach(function(it){
      var row = document.createElement('div');
      row.className = 'expect-item';
      row.innerHTML = '<div class="expect-icon">'+it.icon+'</div><div class="expect-text">'+it.text+'</div>';
      expectList.appendChild(row);
    });

    document.getElementById('checklistIntro').textContent = pastDue
      ? 'Nog niet klaar? Geen paniek, dit kun je ook nog in de eerste dagen regelen.'
      : (weeksPregnant > 27
          ? 'Dit is hét moment om dit plekje echt in te richten.'
          : 'Een rustig plekje waar je straks middenin de nacht comfortabel kan zitten, scheelt enorm.');

    document.getElementById('productTip').style.display = wantsBf ? 'block' : 'none';

    // share card
    var shareHeadline = document.getElementById('shareHeadline');
    var shareDate = document.getElementById('shareDate');
    var shareTip = document.getElementById('shareTip');

    if(pastDue){
      var daysSinceBirth = Math.abs(daysUntil);
      shareHeadline.innerHTML = 'Gefeliciteerd met de geboorte van je kleintje 🎉';
      shareDate.textContent = 'Geboren op ' + due.toLocaleDateString('nl-NL', {day:'numeric', month:'long', year:'numeric'});
      shareTip.textContent = 'Wat leuk dat die ' + daysSinceBirth + (daysSinceBirth === 1 ? ' dag' : ' dagen') + ' oud is.';
    } else {
      shareHeadline.innerHTML = daysUntil + ' <span>' + (daysUntil === 1 ? 'dag' : 'dagen') + '</span><br>te gaan 🤍';
      shareDate.textContent = 'Verwacht op ' + due.toLocaleDateString('nl-NL', {day:'numeric', month:'long', year:'numeric'});
      shareTip.textContent = items[0].text;
    }

    document.getElementById('results').style.display = 'block';
    document.getElementById('results').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ---- newsletter opt-in (native form submit, opens Shopify's newsletter confirmation in a new tab) ----
  var newsletterForm = document.getElementById('newsletterForm');
  var emailStatus = document.getElementById('emailStatus');

  newsletterForm.addEventListener('submit', function(){
    emailStatus.className = 'email-status success';
    emailStatus.textContent = 'Bedankt! We hebben je aanmelding geopend in een nieuw tabblad.';
  });

  // ---- download share card ----
  document.getElementById('downloadBtn').addEventListener('click', function(){
    var card = document.getElementById('shareCard');
    html2canvas(card, { backgroundColor: null, scale: 2 }).then(function(canvas){
      var link = document.createElement('a');
      link.download = 'mijn-countdown.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    }).catch(function(){
      alert('Downloaden lukte helaas niet. Maak een screenshot en deel het alsnog!');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Zwangerschapscalculator"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ---- star field ----
  var starField = document.getElementById('starField');
  var starCount = 45;
  for(var i=0;i<starCount;i++){
    var s = document.createElement('div');
    var big = Math.random() < 0.15;
    var twinkle = Math.random() < 0.35;
    s.className = 'star' + (big ? ' big' : '') + (twinkle ? ' twinkle' : '');
    s.style.left = (Math.random()*100) + '%';
    s.style.top = (Math.random()*85) + '%';
    if(twinkle) s.style.animationDelay = (Math.random()*4) + 's';
    starField.appendChild(s);
  }

  // ---- breastfeeding toggle (just affects copy tone, not gating) ----
  var bfYes = document.getElementById('bfYes');
  var bfNo = document.getElementById('bfNo');
  var wantsBf = true;
  bfYes.addEventListener('click', function(){
    wantsBf = true; bfYes.classList.add('active'); bfNo.classList.remove('active');
  });
  bfNo.addEventListener('click', function(){
    wantsBf = false; bfNo.classList.add('active'); bfYes.classList.remove('active');
  });

  var formError = document.getElementById('formError');

  function expectItemsFor(weeksPregnant, pastDue){
    if(pastDue){
      return [
        {icon:'🎉', text:'Je bent uitgerekend. Je kindje kan nu elk moment komen, of ligt er misschien al.'},
        {icon:'🍼', text:'In de eerste dagen voed je heel vaak: gemiddeld elke 2 tot 3 uur, dag en nacht. Dat is normaal en wordt geleidelijk minder.'},
        {icon:'🫐', text:'Het maagje van een pasgeboren baby is nog piepklein, ongeveer zo groot als een kers, vandaar die frequente voedingen.'}
      ];
    }
    if(weeksPregnant < 28){
      return [
        {icon:'🌱', text:'Je hebt nog alle tijd om je rustig voor te bereiden, geen haast.'},
        {icon:'📋', text:'Een goed moment om alvast na te denken over waar je straks wil voeden, en wat je daarbij fijn zou vinden.'},
        {icon:'💭', text:'Veel ouders merken dat de eerste 6 weken het intensiefst zijn, en dat het daarna geleidelijk makkelijker wordt.'}
      ];
    }
    return [
      {icon:'⏰', text:'De laatste weken zijn een goed moment om je voedingshoekje echt in te richten.'},
      {icon:'🍼', text:'In de eerste weken voed je gemiddeld elke 2 tot 3 uur, dag en nacht, normaal, en het wordt geleidelijk minder.'},
      {icon:'🫐', text:'Het maagje van een pasgeboren baby is nog piepklein, ongeveer zo groot als een kers, vandaar die frequente voedingen.'}
    ];
  }

  document.getElementById('calcBtn').addEventListener('click', function(){
    var val = document.getElementById('dueDate').value;
    if(!val){
      formError.style.display = 'block';
      return;
    }
    formError.style.display = 'none';

    var due = new Date(val + 'T00:00:00');
    var today = new Date();
    today.setHours(0,0,0,0);
    var msPerDay = 1000*60*60*24;
    var daysUntil = Math.round((due - today) / msPerDay);
    var pastDue = daysUntil < 0;

    var weeksPregnant = Math.min(42, Math.max(1, 40 - Math.ceil(daysUntil/7)));

    var countdownLabel = document.getElementById('countdownLabel');
    var countdownNumber = document.getElementById('countdownNumber');
    var countdownUnit = document.getElementById('countdownUnit');
    var trimesterBadge = document.getElementById('trimesterBadge');

    if(pastDue){
      countdownLabel.textContent = 'Je bent uitgerekend, dat is';
      countdownNumber.textContent = Math.abs(daysUntil);
      countdownUnit.textContent = Math.abs(daysUntil) === 1 ? 'dag geleden' : 'dagen geleden';
      trimesterBadge.textContent = 'Voorbij je uitgerekende datum';
    } else {
      countdownLabel.textContent = 'Nog';
      countdownNumber.textContent = daysUntil;
      countdownUnit.textContent = daysUntil === 1 ? 'dag te gaan' : 'dagen te gaan';
      var trimesterText = weeksPregnant <= 13 ? 'Eerste trimester' : (weeksPregnant <= 27 ? 'Tweede trimester' : 'Derde trimester');
      trimesterBadge.textContent = trimesterText + ' (week ' + weeksPregnant + ')';
    }

    var items = expectItemsFor(weeksPregnant, pastDue);
    var expectList = document.getElementById('expectList');
    expectList.innerHTML = '';
    items.forEach(function(it){
      var row = document.createElement('div');
      row.className = 'expect-item';
      row.innerHTML = '<div class="expect-icon">'+it.icon+'</div><div class="expect-text">'+it.text+'</div>';
      expectList.appendChild(row);
    });

    document.getElementById('checklistIntro').textContent = pastDue
      ? 'Nog niet klaar? Geen paniek, dit kun je ook nog in de eerste dagen regelen.'
      : (weeksPregnant > 27
          ? 'Dit is hét moment om dit plekje echt in te richten.'
          : 'Een rustig plekje waar je straks middenin de nacht comfortabel kan zitten, scheelt enorm.');

    document.getElementById('productTip').style.display = wantsBf ? 'block' : 'none';

        // share card
    var shareHeadline = document.getElementById('shareHeadline');
    var shareDate = document.getElementById('shareDate');
    var shareTip = document.getElementById('shareTip');

        if(pastDue){
      var daysSinceBirth = Math.abs(daysUntil);
      shareHeadline.innerHTML = 'Gefeliciteerd met de geboorte van je kleintje 🎉';
      shareDate.textContent = 'Geboren op ' + due.toLocaleDateString('nl-NL', {day:'numeric', month:'long', year:'numeric'});
      shareTip.textContent = 'Wat leuk dat die ' + daysSinceBirth + (daysSinceBirth === 1 ? ' dag' : ' dagen') + ' oud is.';
    } else {
      shareHeadline.innerHTML = daysUntil + ' <span>' + (daysUntil === 1 ? 'dag' : 'dagen') + '</span><br>te gaan 🤍';
      shareDate.textContent = 'Verwacht op ' + due.toLocaleDateString('nl-NL', {day:'numeric', month:'long', year:'numeric'});
      shareTip.textContent = items[0].text;
    }

    document.getElementById('results').style.display = 'block';
    document.getElementById('results').scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ---- newsletter opt-in (native form submit, opens Shopify's newsletter confirmation in a new tab) ----
  var newsletterForm = document.getElementById('newsletterForm');
  var emailStatus = document.getElementById('emailStatus');

  newsletterForm.addEventListener('submit', function(){
    emailStatus.className = 'email-status success';
    emailStatus.textContent = 'Bedankt! We hebben je aanmelding geopend in een nieuw tabblad.';
  });

  // ---- download share card ----
  document.getElementById('downloadBtn').addEventListener('click', function(){
    var card = document.getElementById('shareCard');
    html2canvas(card, { backgroundColor: null, scale: 2 }).then(function(canvas){
      var link = document.createElement('a');
      link.download = 'mijn-countdown.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    }).catch(function(){
      alert('Downloaden lukte helaas niet. Maak een screenshot en deel het alsnog!');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
